import script from "./Employers.vue?vue&type=script&setup=true&lang=ts"
export * from "./Employers.vue?vue&type=script&setup=true&lang=ts"

import "./Employers.vue?vue&type=style&index=0&id=4ea34038&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ea34038"]])

export default __exports__